import { defineMessage } from 'services/localization';

export const messages = {
    addFieldTitle: defineMessage('add_new_or_existing_fields_to_be_used_in_rules'),
    addFieldPlaceholder: defineMessage('name_a_field'),
    addField: defineMessage('add_a_field'),
};
